// ** React Imports
import { useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import FormGroup from '@mui/material/FormGroup'
import Typography from '@mui/material/Typography'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'

// ** Third Party Imports
import { useForm, Controller } from 'react-hook-form'
import { client } from '../../utils/axios-client'
import AddIcon from '@mui/icons-material/Add'
import RenderIf, { ClaimType, ClaimValue } from '../common/RenderIf'

interface Props {
    onAddRecord: () => void,
    title: string,
    buttonLabel: string,
    value: string,
    onFilter: (value: string) => void
}

const TableHeader = ({ onAddRecord, buttonLabel, title, value, onFilter }: Props) => {
    return (
        <>
            <Box
                sx={{ p: 5, pb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <TextField
                    size='small'
                    value={value}
                    sx={{ mr: 4, mb: 2 }}
                    placeholder={title}
                    onChange={e => onFilter(e.target.value)}
                />
                <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.Add}>
                    <Button sx={{ mb: 2 }} variant='contained' onClick={onAddRecord} startIcon={<AddIcon />} size="small">
                        {buttonLabel}
                    </Button>
                </RenderIf>
                
            </Box>
        </>
    )
}

export default TableHeader
